import Sandbox from "./Sandbox";
import Preview from "./Preview";
import Text from "./Text";
import Code from "./Code";

import "./sandbox.scss";

Sandbox.Preview = Preview;
Sandbox.Code = Code;
Sandbox.Text = Text

export default Sandbox;
